import { render, staticRenderFns } from "./edu-toolbar.vue?vue&type=template&id=79567b70&scoped=true"
import script from "./edu-toolbar.vue?vue&type=script&lang=js"
export * from "./edu-toolbar.vue?vue&type=script&lang=js"
import style0 from "./edu-toolbar.vue?vue&type=style&index=0&id=79567b70&prod&lang=less&scoped=true"
import style1 from "./edu-toolbar.vue?vue&type=style&index=1&id=79567b70&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79567b70",
  null
  
)

export default component.exports